"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
const { MISSING, PENDING, REFUSED, VALIDATED } = constants_1.SHINE_START_DOCUMENT_STATUS;
/*
 * Compute shine start overall documents list status
 */
const getDocumentsStatus = (documents = []) => {
    if (documents.some(({ status }) => status === MISSING))
        return MISSING;
    if (documents.some(({ status }) => status === PENDING))
        return PENDING;
    if (documents.some(({ status }) => status === REFUSED))
        return REFUSED;
    if (documents.every(({ status }) => status === VALIDATED))
        return VALIDATED;
    return MISSING;
};
exports.default = getDocumentsStatus;
